import { AUTHORIZATION_ACTIONS } from "./actionTypes";
export const AuthorizationSelector = {
  userRole: state => state.authorization[AUTHORIZATION_ACTIONS.USER_ROLE],
  usersRoles: state => state.authorization[AUTHORIZATION_ACTIONS.USERS_ROLES],
  setUserRole: state => state.authorization[AUTHORIZATION_ACTIONS.SET_USER_ROLE]
};